(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-halloween"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ikier-halloween-tabs')) {
    customElements.define('ikier-halloween-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tablist = this.querySelector('[role="tablist"]');
        if (!this.tabs.length) return;

        this.mobile = window.matchMedia('(max-width: 767px)');
        const setOrientation = () => {
          this.tablist.setAttribute('aria-orientation', this.hasAttribute('data-horizontal') || this.mobile.matches ? 'horizontal' : 'vertical');
        };
        setOrientation();
        this.mobile.addEventListener('change', setOrientation, options);

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[role="tab"]');
          const index = this.tabs.indexOf(tab);
          if (index >= 0) this.activate(index);
        }, options);

        this.addEventListener('keydown', (event) => {
          const index = this.tabs.indexOf(event.target);
          if (index < 0) return;
          const horizontal = this.tablist.getAttribute('aria-orientation') === 'horizontal';
          const previousKey = horizontal ? 'ArrowLeft' : 'ArrowUp';
          const nextKey = horizontal ? 'ArrowRight' : 'ArrowDown';
          let nextIndex;
          if (event.key === previousKey) nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === nextKey) nextIndex = (index + 1) % this.tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(nextIndex);
          this.tabs[nextIndex].focus();
        }, options);


        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-product-variant]');
          if (!select) return;
          const card = select.closest('[data-product-card]');
          const option = select.selectedOptions[0];
          if (!card || !option) return;
          const data = option.dataset;
          card.querySelector('[data-current-price]').textContent = data.price;
          const compare = card.querySelector('[data-compare-price]');
          compare.textContent = data.compare;
          compare.hidden = !data.compare;
          const saving = card.querySelector('[data-saving-label]');
          saving.textContent = data.saving;
          saving.hidden = !data.saving;
          const available = data.available === 'true';
          const buy = card.querySelector('[data-buy-now]');
          buy.textContent = available ? this.dataset.buyLabel : this.dataset.soldOutLabel;
          if (available) {
            buy.href = data.checkout;
            buy.removeAttribute('aria-disabled');
            buy.removeAttribute('tabindex');
          } else {
            buy.removeAttribute('href');
            buy.setAttribute('aria-disabled', 'true');
            buy.tabIndex = -1;
          }
          card.querySelector('[data-learn-more]').href = data.url;
          const image = card.querySelector('.halloween-product__image img');
          if (image && data.image) {
            image.removeAttribute('srcset');
            image.src = data.image;
          }
        }, options);

        this.addEventListener('click', async (event) => {
          const button = event.target.closest('[data-copy-code]');
          if (!button) return;
          const coupon = button.closest('.halloween-product__coupon');
          const status = coupon.querySelector('[data-copy-status]');
          button.disabled = true;
          try {
            await navigator.clipboard.writeText(button.dataset.copyCode);
            status.textContent = this.dataset.copySuccess;
          } catch {
            const range = document.createRange();
            range.selectNodeContents(coupon.querySelector('[data-code-text]'));
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            status.textContent = this.dataset.copyFailed;
          } finally {
            button.disabled = false;
          }
        }, options);

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.contains(event.target)) return;
          const panel = event.target.closest('[role="tabpanel"]');
          const index = panel ? this.panels.indexOf(panel) : this.panels.findIndex((item) => item.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.activate(index);
        }, options);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      activate(index) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });
      }
    });
  }

  if (!window.ikierHalloweenAccessoryBound) {
    window.ikierHalloweenAccessoryBound = true;
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-accessory-variant]');
      if (!select) return;
      const card = select.closest('[data-accessory-card]');
      const option = select.selectedOptions[0];
      if (!card || !option) return;
      const data = option.dataset;
      const price = card.querySelector('[data-current-price]');
      if (price) price.textContent = data.price || '';
      const compare = card.querySelector('[data-compare-price]');
      if (compare) {
        compare.textContent = data.compare || '';
        compare.hidden = !data.compare;
      }
      const saving = card.querySelector('[data-saving-label]');
      if (saving) {
        saving.textContent = data.saving || '';
        saving.hidden = !data.saving;
      }
      const button = card.querySelector('[data-accessory-submit]');
      if (button) {
        const available = data.available === 'true';
        button.disabled = !available;
        button.textContent = available ? card.dataset.addLabel : card.dataset.soldOutLabel;
      }
      const image = card.querySelector('.halloween-accessory__media img');
      if (image && data.image) {
        image.removeAttribute('srcset');
        image.src = data.image;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-ikier-flex-pro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('flex-pro-materials')) {
  customElements.define('flex-pro-materials', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.groups = new Map();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index), options);
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index + this.tabs.length - 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.tabs[next].focus();
          this.activate(next);
        }, options);
      });

      const initialize = () => {
        if (!this.isConnected || !this.nearViewport || typeof Splide === 'undefined') return;
        this.activate(Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true')));
      };
      this.nearViewport = false;
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.nearViewport = true;
        this.observer.disconnect();
        initialize();
      }, { rootMargin: '800px 0px' });
      this.observer.observe(this);
      if (typeof Splide === 'undefined') {
        window.addEventListener('load', initialize, { ...options, once: true });
      }
    }

    activate(index) {
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        this.panels[tabIndex].hidden = !active;
      });
      if (typeof Splide === 'undefined') return;
      const panel = this.panels[index];
      const existing = this.groups.get(panel);
      if (existing) {
        existing.gallery.refresh();
        existing.navigation.refresh();
        this.loadActiveImage(existing.gallery, panel);
        return;
      }
      const gallery = new Splide(panel.querySelector('[data-material-gallery]'), {
        type: 'fade',
        rewind: true,
        perPage: 1,
        arrows: false,
        pagination: false,
        speed: 350,
      });
      const navigation = new Splide(panel.querySelector('[data-material-nav]'), {
        perPage: 8,
        perMove: 1,
        gap: 24,
        isNavigation: true,
        arrows: false,
        pagination: false,
        focus: 0,
        breakpoints: { 767: { perPage: 3, gap: 8, arrows: true } },
      });
      gallery.sync(navigation);
      gallery.on('mounted', () => this.loadActiveImage(gallery, panel));
      gallery.on('move', index => this.loadActiveImage(gallery, panel, index));
      gallery.mount();
      navigation.mount();
      this.groups.set(panel, { gallery, navigation });
    }

    loadImage(image, priority = 'auto') {
      if (!image) return;
      image.fetchPriority = priority;
      image.loading = 'eager';
      image.closest('picture').querySelectorAll('source[data-srcset]').forEach((source) => {
        source.srcset = source.dataset.srcset;
        source.removeAttribute('data-srcset');
      });
      if (image.dataset.srcset) {
        image.srcset = image.dataset.srcset;
        image.removeAttribute('data-srcset');
      }
      if (image.dataset.src) {
        image.src = image.dataset.src;
        image.removeAttribute('data-src');
      }
    }

    loadActiveImage(gallery, panel, index = gallery.index) {
      const images = panel.querySelectorAll('[data-material-gallery] img');
      const image = images[index];
      if (!image) return;
      this.loadImage(image);
      if (!navigator.connection?.saveData) {
        this.loadImage(images[(index + 1) % images.length], 'low');
      }
      const refresh = () => {
        if (this.isConnected && !panel.hidden) gallery.refresh();
      };
      if (image.complete && image.naturalWidth) {
        requestAnimationFrame(refresh);
      } else {
        image.addEventListener('load', refresh, {
          once: true,
          signal: this.controller.signal,
        });
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.groups?.forEach(({ gallery, navigation }) => {
        gallery.destroy();
        navigation.destroy();
      });
      this.groups?.clear();
    }
  });
}

if (!customElements.get('flex-pro-scenarios')) {
  customElements.define('flex-pro-scenarios', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const items = Array.from(this.querySelectorAll('.ikier-flex-pro__scenario'));
      const images = Array.from(this.querySelectorAll('[data-scenario-image]'));
      const buttons = items.map(item => item.querySelector('button'));
      const desktop = window.matchMedia('(min-width: 768px)');
      const loadImage = (index) => {
        const image = desktop.matches ? images[index] : items[index].querySelector('img');
        image.loading = 'eager';
      };
      const loadActiveImage = () => loadImage(Math.max(0, items.findIndex(item => item.classList.contains('is-active'))));
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        loadActiveImage();
        this.observer.disconnect();
      }, { rootMargin: '600px 0px' });
      this.observer.observe(this);
      desktop.addEventListener('change', loadActiveImage, options);
      const activate = (index) => {
        items.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          buttons[itemIndex].setAttribute('aria-expanded', String(active));
          item.querySelector('.ikier-flex-pro__scenario-panel').hidden = !active;
          images[itemIndex].hidden = !active;
          if (active) {
            loadImage(itemIndex);
          }
        });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(index), options);
        button.addEventListener('pointerenter', () => loadImage(index), options);
        button.addEventListener('focus', () => loadImage(index), options);
        button.addEventListener('keydown', (event) => {
          let target;
          if (event.key === 'ArrowDown') target = (index + 1) % buttons.length;
          if (event.key === 'ArrowUp') target = (index + buttons.length - 1) % buttons.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = buttons.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          buttons[target].focus();
        }, options);
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
